/**
 * Design-system tokens for the /phone v2 workspace.
 * Sourced verbatim from PART 1 of the rebuild spec:
 *
 *   navy   #143875  header, active tab, text/icons on gold
 *   royal  #2A7CC4  all secondary action icons
 *   gold   #FFCC1A  status bar, counts, primary "create" buttons
 *   green  #1D9E75  connect to a live phone line ONLY
 *   red    #C0392B  hang up and missed ONLY
 *   amber  #BA7517  needs attention (unnamed numbers)
 *
 * Never used for anything else. Any "make this pop" ask that isn't one
 * of the six semantic slots gets an existing CSS variable so dark mode
 * doesn't break. Kept as constants (not tailwind) so they can flow
 * straight into inline `style={{ }}` where the shared component library
 * lacks a semantic slot.
 */
export const NAVY   = "#143875";
export const ROYAL  = "#2A7CC4";
export const GOLD   = "#FFCC1A";
export const GREEN  = "#1D9E75";
export const RED    = "#C0392B";
export const AMBER  = "#BA7517";

// Tints used for row background accents and neutral fills. Kept as
// rgba() so contrast tests continue to pass on both light and dark
// backgrounds. Do NOT introduce new tints without checking WCAG AA.
export const NAVY_TINT      = "rgba(20,56,117,0.06)";
export const NAVY_TINT_STRG = "rgba(20,56,117,0.10)";
export const NAVY_HAIRLINE  = "rgba(20,56,117,0.10)";

// STATUS accent — colored border applied to list rows (left border) or
// cards (top border). See PART 1 STATUS LANGUAGE.
//   red     = unreturned / failed
//   royal   = unread / unheard / pending
//   amber   = unnamed number, needs a name
//   none    = handled  (transparent)
export function statusAccent(entry) {
  if (!entry) return "transparent";
  if (entry.needsCallback) return RED;
  if (entry.unheardVm || entry.unreadSms) return ROYAL;
  if (entry.needsRename) return AMBER;
  return "transparent";
}

// Handled items drop to 72% opacity and lose their accent (PART 1).
export function handledOpacity(entry) {
  return entry?.handled ? 0.72 : 1;
}
